export default __webpack_public_path__ + "static/media/linknet_logo.5505b62e.svg";